module.exports = __webpack_public_path__ + "static/media/pending.fd4b0536.svg";